<template>
  <form
    class="search-form"
    action="/search"
    method="get"
  >
    <!-- TODO: автофокус на мобиле после анимации -->
    <!-- https://jira.app.local/browse/ESMFUN-675 -->
    <ui-input
      :large="adaptive.isDesktop"
      :autofocus="adaptive.isDesktop"
      v-model="query"
      name="query"
      placeholder="Например, блузка женская"
      clearable
    >
      <vue-client-only>
        <f-sprite-icon :icon-link="$options.icons.IconSearch.id" slot="prepend" v-if="adaptive.isDesktop" />
      </vue-client-only>
    </ui-input>
  </form>
</template>

<script>
import VueClientOnly from 'vue-client-only';

/* Icons */
import IconSearch from '../../assets/icons/search.svg';

const maxLength = 255;

export default {
  name: 'search-form',

  components: {
    VueClientOnly,
  },

  inject: ['adaptive'],

  data: () => ({
    query: '', // используется для очистки
  }),

  icons: {
    IconSearch,
  },

  watch: {
    'query.length'(l) {
      if (l > maxLength) {
        this.query = this.query.slice(0, maxLength);
      }
    }
  }
};
</script>

<style lang="scss">
.search-form {
  position: relative;
}

@include breakpoint("desktop") {
  .search-form {
    .ui-input {
      padding: 0 16px;

      input {
        font-size: 16px;
      }
    }
  }
}
</style>